import { action } from 'satcheljs';
import { AriaLiveLevel } from '../store/schema/AccessibilityStore';

/**
 * This will add the passed Arialabel to the list of Arialabels which are to be listened by the screenreader
 * Consumer components which want themselves to be registered to listen and read the changes in them by the screen reader
 * must use this function/action in componentDidMount by passing the desired localised string to be read as the parameter
 * @param ariaLiveLabel The localised change string which needs to be announced by the screenreader on a change in the consuming component
 * @param ariaLiveLevel The level of politeness needed ( optional ) and default value is polite
 */
export default action(
    'addAriaLiveLabel',
    function addAriaLiveLabel(
        ariaLiveLabel: string,
        ariaLiveLevel: AriaLiveLevel = 'polite'
    ): { ariaLiveLabel: string; ariaLiveLevel: AriaLiveLevel } {
        return { ariaLiveLabel, ariaLiveLevel };
    }
);
